<template>
<!--    <main-layout>-->
        <div id="eight-ball">
            {{this.$router.path}}
            <!--    <img alt="Vue logo" src="./assets/logo.png">-->
            <EightBall></EightBall>
        </div>
<!--    </main-layout>-->

</template>

<script>
// eslint-disable-next-line no-unused-vars
var _ = require('lodash');
// eslint-disable-next-line no-unused-vars
const axios = require('axios');
// axios.defaults.timeout = 1000;
// import MainLayout from './layout/Main.vue'

import EightBall from './components/EightBall.vue'

export default {
  name: 'app',
  components: {
      EightBall //MainLayout,
  }
}
</script>

<style>
#eight-ball {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
